import { render, staticRenderFns } from "./info-transport.vue?vue&type=template&id=0d64228e&scoped=true&"
import script from "./info-transport.vue?vue&type=script&lang=js&"
export * from "./info-transport.vue?vue&type=script&lang=js&"
import style0 from "./info-transport.vue?vue&type=style&index=0&id=0d64228e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d64228e",
  null
  
)

export default component.exports